import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  NbToggleModule,
  NbIconLibraries,
  NbIcon,
  NbIconComponent,
  NbSvgIcon,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';

import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';
import { MATERIAL_LIGHT_THEME } from './styles/material/theme.material-light';
import { MATERIAL_DARK_THEME } from './styles/material/theme.material-dark';
// import '@fortawesome/fontawesome-free/css/all.css';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbToggleModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];

@NgModule({
  imports: [CommonModule, MatRippleModule, ...NB_MODULES],
  exports: [CommonModule, MatRippleModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {

  constructor(private iconLibraries: NbIconLibraries) {
    this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fas', iconClassPrefix: '' });
    this.iconLibraries.registerSvgPack('social-networks', { source: '../../assets/svg-icons' });

    this.iconLibraries.getPack("eva").icons.set(
      "metric", "<img src='../../assets/svg-icons/metric.svg' width='22px' style='position: relative; top: -3px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "metric_group", "<img src='../../assets/svg-icons/metric_group.svg' width='32px' style='position: relative; top: -6px; left: -6px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "metric_light", "<img src='../../assets/svg-icons/metric_light.svg' width='22px' style='position: relative; top: -3px; left: -3px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "link_doc", "<img src='../../assets/svg-icons/link_doc.svg' width='22px' style='position: relative; top: -3px; left: -3px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "open_link", "<img src='../../assets/svg-icons/open_link.svg' width='22px' style='position: relative; top: -3px; left: -3px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "link", "<img src='../../assets/svg-icons/link.svg' width='22px' style='position: relative; top: -3px; left: -3px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "pdf", "<img src='../../assets/svg-icons/pdf.svg' width='22px' style='position: relative; top: -3px; left: -3px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "report_light", "<img src='../../assets/svg-icons/report_light.svg' width='22px' style='position: relative; top: -3px; left: -3px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "device", "<img src='../../assets/svg-icons/device.svg' width='22px' style='position: relative; top: -6px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "report", "<img src='../../assets/svg-icons/report.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "chargingb", "<img src='../../assets/svg-icons/chargingb.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "station", "<img src='../../assets/svg-icons/ev_charger.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "rfid", "<img src='../../assets/svg-icons/rfid.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "ev_charger", "<img src='../../assets/svg-icons/ev.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "ev_dash", "<img src='../../assets/svg-icons/ev_dash.svg' width='20px' style='position: relative; top: -2px; left: 0px;'/>"
    );



    this.iconLibraries.getPack("eva").icons.set(
      "EPC", "<img src='../../assets/svg-icons/EPC.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

    this.iconLibraries.getPack("eva").icons.set(
      "app", "<img src='../../assets/svg-icons/app.svg' width='22px' style='position: relative; top: -2px; left: 0px;'/>"
    );

  }

  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [ CORPORATE_THEME, DARK_THEME, MATERIAL_LIGHT_THEME, MATERIAL_DARK_THEME],
        ).providers??[],
      ],
    };
  }
}
